export default __webpack_public_path__ + "static/media/Group 1296.a76fb7e4.svg";